// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-media-remove-icon{font-size:12px;color:red;cursor:pointer;position:absolute;top:-5px;right:25px}`, "",{"version":3,"sources":["webpack://./resources/app/core/components/form/form_upload.scss"],"names":[],"mappings":"AAAA,0BACE,cAAA,CACA,SAAA,CACA,cAAA,CACA,iBAAA,CACA,QAAA,CACA,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
